import { useCallback } from 'react';

import { useFeatureFlag } from '@order/LaunchDarkly';

import { useOrderLastPendingFeedbackQuery } from './OrderLastPendingFeedback.query.generated';

/**
 * We do not fully support in-store orders.
 * Yet we still need to allow them to be rated.
 *
 * Rather than returning those orders in the history,
 * we return only the Order ID related to it.
 */

export const useOrderPendingFeedbackId = () => {
  const isFeatureEnabled = useFeatureFlag(
    'XP-3212-short-in-store-order-feedback-enabled',
  );

  const [response, reFetchFeedback] = useOrderLastPendingFeedbackQuery({
    requestPolicy: 'network-only',
    pause: isFeatureEnabled,
  });
  const orderPendingFeedbackId = response?.data?.orderLastPendingFeedback?.id;

  const handleReFetchFeedback = useCallback(() => {
    if (isFeatureEnabled) reFetchFeedback();
  }, [isFeatureEnabled, reFetchFeedback]);

  return { orderPendingFeedbackId, reFetchFeedback: handleReFetchFeedback };
};
